import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';
import { Box, Flex, MenuLinkButton, VersionLabel } from '@/components/common';
import { AccountSubpageShell } from '@/components/layout';
import { openIubendaPreferences } from '@/contexts';

const HUB_LINKS = [
  {
    to: '/account/settings/preferences',
    titleKey: 'hub.preferences.title' as const,
    subtitleKey: 'hub.preferences.subtitle' as const,
  },
  {
    to: '/account/settings/blocked',
    titleKey: 'hub.blocked.title' as const,
    subtitleKey: 'hub.blocked.subtitle' as const,
  },
  {
    to: '/account/settings/account',
    titleKey: 'hub.account.title' as const,
    subtitleKey: 'hub.account.subtitle' as const,
  },
];

export function SettingsPage() {
  const { t } = useTranslation('settings');
  const navigate = useNavigate();

  return (
    <AccountSubpageShell onBack={() => navigate('/account')} title={t('title')}>
      <Flex direction="column" gap="3">
        {HUB_LINKS.map(({ to, titleKey, subtitleKey }) => (
          <MenuLinkButton
            key={to}
            to={to}
            title={t(titleKey)}
            subtitle={t(subtitleKey)}
            data-testid={to.replace(/\//g, '-').slice(1)}
          />
        ))}
        <MenuLinkButton
          title={t('hub.consent.title')}
          subtitle={t('hub.consent.subtitle')}
          onClick={openIubendaPreferences}
          data-testid="consent"
        />
        <Box mt="3" mb="4" alignSelf="center">
          <VersionLabel />
        </Box>
      </Flex>
    </AccountSubpageShell>
  );
}
